module.exports = __webpack_public_path__ + "static/img/payment-status-success.9503fc15.png";